import { VariablesContext } from "src/types/messages/variables";

export type VariableMode = "expanded" | "collapsed";

export type Settings = {
  enableBackgroundColor: boolean;
  enableFontColor: boolean;
  enableFontFamily: boolean;
  enableFontSize: boolean;
  hasLinkAttributes: boolean;
  enableVariables: boolean;
  enableSmsStats: boolean;
  variablesContext?: VariablesContext;
  variableMode: VariableMode;
  clearErrorsOnChange: boolean;
  hideToolbar?: boolean;
  enableAutofocus: boolean;
  plainFieldName?: string;
  htmlFieldName?: string;
  jsonFieldName?: string;
  enableTextFormat: boolean;
  enableBlockFormat: boolean;
  enableCode: boolean;
  enableLink: boolean;
  enableHorizontalRule: boolean;
  enableImage: boolean;
  enableElementFormat: boolean;
  enableUndo: boolean;
};

export type SettingName = keyof Settings;

export const DEFAULT_SETTINGS: Settings = {
  enableBackgroundColor: false,
  enableFontColor: false,
  enableFontFamily: false,
  enableFontSize: false,
  hasLinkAttributes: false,
  enableVariables: false,
  enableSmsStats: false,
  clearErrorsOnChange: true,
  enableAutofocus: false,
  variableMode: "expanded",
  enableTextFormat: true,
  enableBlockFormat: true,
  enableCode: true,
  enableLink: true,
  enableHorizontalRule: true,
  enableImage: true,
  enableElementFormat: true,
  enableUndo: true,
} as const;

// These are mutated in setupEnv
export const INITIAL_SETTINGS: Settings = {
  ...DEFAULT_SETTINGS,
};
